import React,{useState, useEffect} from "react";
import Camera from '../images/Camera.svg';
import CameraOff from '../images/Camera-off.svg';
import rotateblue from '../images/rotateblue.svg';
import cameraClick from '../images/camera-Click.svg';
import ReactGA from "react-ga4";

export default function CameraBar(props){

    const [enabled, setEnabled] = useState(false);

    const [camera, setCamera] = useState(false);

    const [clickMode, setClickMode ] = useState(false);


    function toggleCamera(){
        props.onAutoRotateClicked(false)
        setCamera(false)
    }

    function toggleCloseCamera(){
        props.onAutoRotateClicked(true)
        setCamera(true)
    }

    useEffect(() => {
        setTimeout(() => {
            setEnabled(true)
          }, "200")
    }, [])
   
    
    const onMouseDownHandler = () => {
        setClickMode(true);
        // console.log("onMouseDown Event!");
    };

    const onMouseUpHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
    };

    const onMouseLeaveHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
    };

    return(
        <div>
           {(camera)?        
               ( <div className="camera-item" onClick={() =>{ 
                        toggleCamera()
                        ReactGA.event({category: 'Engagement',action: "ui_autoRotate_on",value: 1})
                    }}> 
                    <img src={(clickMode == true)? cameraClick : Camera} 
                        onMouseDown={onMouseDownHandler}
                        onMouseUp={onMouseUpHandler}
                        onMouseLeave={onMouseLeaveHandler}
                        onTouchMove={onMouseLeaveHandler}
                        onTouchCancel={onMouseLeaveHandler}
                        onTouchStart={onMouseDownHandler}
                        onTouchEnd={onMouseUpHandler}
                        alt="Logo" 
                        className={(clickMode == true)? "camera-clicked-icon":"camera--icon"}
                    />
                </div>)
            
            :

                (<div className="camera-item" onClick={() => {
                        toggleCloseCamera()
                        ReactGA.event({category: 'Engagement',action: "ui_autoRotate_off",value: 1})
                    }}> 
                    <img src={(clickMode == true)? rotateblue : CameraOff}
                        alt="Logo" 
                        className={(clickMode == true)? "camera-clicked-icon":"camera--icon"}
                        onMouseDown={onMouseDownHandler}
                        onMouseUp={onMouseUpHandler}
                        onMouseLeave={onMouseLeaveHandler}
                        onTouchMove={onMouseLeaveHandler}
                        onTouchCancel={onMouseLeaveHandler}
                        onTouchStart={onMouseDownHandler}
                        onTouchEnd={onMouseUpHandler}
                    />
                </div>)
            
            }
   
        </div>

    )         
}